import CraftTableHelper from './craft-table-helper';
import craftFuncHelper from './craft-functions-helper';


const CraftHelpers = {
    TableMain: CraftTableHelper,
    Functions: craftFuncHelper,
}

export default CraftHelpers;